module.exports = __webpack_public_path__ + "static/flags/WF-ea01e852a38f9dd5b84e2a95ef0c6b2e.gif";